export default {"src":"/_next/static/media/back-arraow-white-icon.be51ffb9.svg","height":30,"width":26};